import { Reveal } from "./Reveal";

const STEPS = [
  {
    number: "01",
    title: "FIND",
    subtitle: "Broadcast or discover",
    desc: "State precisely what you need — or what skill, asset or resource you can bring to the network.",
  },
  {
    number: "02",
    title: "CONNECT",
    subtitle: "Meet at the X",
    desc: "Get introduced directly to the right people, businesses and decision-makers. No noise, no cold outreach.",
  },
  {
    number: "03",
    title: "GROW",
    subtitle: "Compound the connection",
    desc: "Turn a single introduction into deals, ventures and long-term collaborations that grow both sides.",
  },
];

export const HowItWorks = () => (
  <section id="how-it-works" data-testid="how-it-works-section" className="relative py-28 lg:py-36 border-t border-white/5 bg-grid">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <Reveal className="flex flex-wrap items-end justify-between gap-6">
        <div>
          <span className="font-mono-accent text-xs tracking-[0.3em] text-[#00F0FF]" data-testid="how-eyebrow">
            /// THE PROTOCOL
          </span>
          <h2 className="mt-6 font-display font-extrabold uppercase text-3xl sm:text-4xl lg:text-5xl leading-[1.02] text-slate-100" data-testid="how-title">
            How it works
          </h2>
        </div>
        <p className="max-w-sm text-slate-500 text-sm sm:text-base leading-relaxed">
          Three moves. One network. Every journey on FINDXCHANGE follows the same arc.
        </p>
      </Reveal>

      <div className="mt-16 grid md:grid-cols-3 gap-px bg-white/10 border border-white/10">
        {STEPS.map((s, i) => (
          <Reveal key={s.number} delay={i * 0.12} className="h-full">
            <div className="card-frame group relative h-full p-10 lg:p-12 overflow-hidden" data-testid={`how-step-${s.number}`}>
              <span className="font-display font-extrabold text-7xl lg:text-8xl leading-none text-outline transition-all duration-500 group-hover:text-outline-cyan">
                {s.number}
              </span>
              <h3 className="mt-8 font-display font-extrabold uppercase text-2xl lg:text-3xl text-slate-100 tracking-tight">
                {s.title}
              </h3>
              <p className="mt-2 font-mono-accent text-[11px] uppercase tracking-[0.25em] text-[#00F0FF]">
                {s.subtitle}
              </p>
              <p className="mt-5 text-sm sm:text-base text-slate-400 leading-relaxed">{s.desc}</p>
              <span className="absolute bottom-0 left-0 h-px w-0 bg-[#00F0FF] transition-all duration-700 group-hover:w-full" />
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
